import { render, staticRenderFns } from "./CardSustainability.vue?vue&type=template&id=019e9f5f&scoped=true&"
import script from "./CardSustainability.vue?vue&type=script&lang=ts&"
export * from "./CardSustainability.vue?vue&type=script&lang=ts&"
import style0 from "./CardSustainability.vue?vue&type=style&index=0&id=019e9f5f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019e9f5f",
  null
  
)

export default component.exports